function getStoriesForCategories(stories, categories) {
  if (!stories) {
    return [];
  }

  return stories
    .filter(story => categories.some(category => story.hazardCategories.includes(category)))
    .sort((a, b) => new Date(a.createdAt) - new Date(b.createdAt))
    .slice(0, 3);
}

export {
  getStoriesForCategories,
};